<template>
<div class="confirm-icon" :class="{corner}">
    <v-menu offset-y left :nudge-top="18">
        <template v-slot:activator="{ on }">
            <div @click.prevent v-on="on" style="border-radius:99px;background-color:rgba(255,255,255,0.3)">
                <v-btn :small="small" icon>
                    <v-icon :small="small">close</v-icon>
                </v-btn>
            </div>
        </template>
        <v-card class="pa-4 center-text">
            <div>
                Are you sure?
            </div> 
            <div>
                <v-icon class="alert-icon grey--text text--lighten-2" :class="{small}">mdi-alert-circle</v-icon>
            </div>
            <v-btn @click="$emit('click')" class="error">Confirm</v-btn>
        </v-card>
    </v-menu>  
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        item: Object,
        small: Boolean,
        corner: Boolean,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    }
}
</script>

<style scoped>

    .alert-icon {
        font-size:80px;
    }
    .alert-icon.small {
        font-size:40px;
    }
    .confirm-icon {
        opacity: .7;
        display:inline-block;
    }
    .confirm-icon.corner {
        position:absolute;
        top: -3px;
        right: -3px;
        z-index:1;
    }
    .confirm-icon:hover {
        opacity: 1;
        color:red!important;
    }
</style>




// WEBPACK FOOTER //
// ConfirmIcon.vue?786af0da